import 'dayjs/locale/it';
